module.exports = __webpack_public_path__ + "img/first-1.239fb881.jpg";